/**
 * Format Money Utility
 * ====================
 * 
 * Converts price in cents to a formatted money string using Shopify's money format.
 * 
 * @module utils/format-money
 * 
 * @example
 * // Basic usage
 * formatMoney(4400, '${{amount}}') // Returns "$44.00"
 * 
 * @example
 * // Without decimals
 * formatMoney(4400, '${{amount_no_decimals}}') // Returns "$44"
 */

/**
 * Format money value from cents to formatted string
 * 
 * @param {number} cents - Price in cents (e.g., 4400 for $44.00)
 * @param {string} [moneyFormat='${{amount}}'] - Shopify money format string
 * @returns {string} Formatted money string (e.g., "$44.00")
 * 
 * @example
 * formatMoney(3960, '${{amount}}') // "$39.60"
 * formatMoney(11220, '${{amount}}') // "$112.20"
 */
export function formatMoney(cents, moneyFormat = '${{amount}}') {
  const amount = (cents / 100).toFixed(2);
  return moneyFormat
    .replace('{{amount}}', amount)
    .replace('{{amount_no_decimals}}', Math.round(cents / 100));
}

export default formatMoney;
